import { useState } from 'react';
import { topicWall } from '@/mocks/kanliao';

export default function KeywordWall() {
  const [selected, setSelected] = useState<string[]>(['今日热播榜']);

  const toggle = (w: string) => {
    setSelected((prev) =>
      prev.includes(w) ? prev.filter((x) => x !== w) : [...prev, w],
    );
  };

  return (
    <section id="wall" className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6">
      <div className="flex flex-col gap-1 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="text-xs font-semibold tracking-wide text-orange-500">TOPIC WALL</span>
          <h2 className="mt-1 text-2xl font-black tracking-tight text-stone-900 md:text-3xl">
            大家都在搜的话题墙
          </h2>
          <p className="mt-2 text-sm text-stone-500">
            常刷的话题都归在这儿，点一下即可筛选，省得反复输入搜索。
          </p>
        </div>
        <span className="mt-2 whitespace-nowrap text-xs text-stone-400">
          已选 {selected.length} 个 · 可多选
        </span>
      </div>

      <div className="mt-6 flex flex-wrap gap-2.5 rounded-2xl border border-stone-200/80 bg-white/70 p-5">
        {topicWall.map((w) => {
          const active = selected.includes(w);
          return (
            <button
              key={w}
              type="button"
              onClick={() => toggle(w)}
              className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-3.5 py-1.5 text-sm transition-colors ${
                active
                  ? 'border-orange-500 bg-orange-500 text-white'
                  : 'border-stone-200 bg-white text-stone-600 hover:border-orange-300 hover:text-orange-600'
              }`}
            >
              {active && <i className="ri-check-line" />}
              {w}
            </button>
          );
        })}
      </div>

      <p className="mt-3 text-xs text-stone-400">
        正在关注：{selected.length ? selected.join(' / ') : '暂无筛选，点击上方话题开始'}
      </p>
    </section>
  );
}